import React from "react";

const branches = [
    {
        name: "Lagos (Head Office)",
        address: "75 Mobolaji Bank Anthony Way, Ikeja, Lagos"
    },
    {
        name: "Sokoto Branch",
        address: "White Plaza, Gada Aliu Flyover, beside Union Bank, Sokoto State"
    },
    {
        name: "Yola Branch",
        address: "No. 1, Unity Flyover, Police Roundabout, Jimeta Yola, Adamawa State"
    },
    {
        name: "Calabar Branch",
        address: "No. 80 MCC Road, Close to Effio-Ette Roundabout, Calabar, Cross River State"
    },
    {
        name: "Abuja Branch",
        address: "Suite No 47, Nurnberger Platz, Ademola Adetokumbo Crescent, Wuse 2, Abuja"
    }
];

const ContactUs = () => {
    const openFacebook = () => { window.open('https://www.facebook.com/CheckoffFinance', '_blank') }
    const openInstagram = () => { window.open('https://instagram.com/checkoff.finance?igshid=NzNkNDdiOGI=', '_blank') }
    const openWhatsapp = () => { window.open('https://wa.me/message/AAU5TDSUAWEWI1', '_blank') }
    return (
        <div className="contact">
            <div className="contact-us">
                <div>
                    <h1 className="display-lap">
                        How can <br />
                        we help?
                    </h1>
                    <div className="phone-text-center">
                        <p className="mt-4">Connect with us on social media </p>
                        <div className="contact-us-socials">
                            <button
                                onClick={openFacebook}
                                style={{ marginLeft: "-10px" }}
                                className="btn border-0"
                            >
                                <img
                                    src={`${process.env.PUBLIC_URL}/assets/icons/facebook-contact-us.svg`}
                                    alt="facebook-logo"
                                />
                            </button>
                            <button onClick={openInstagram} className="btn border-0">
                                <img
                                    src={`${process.env.PUBLIC_URL}/assets/icons/instagram-contact-us.svg`}
                                    alt="instagram-logo"
                                />{" "}
                            </button>
                            <button onClick={openWhatsapp} className="btn border-0">
                                <img
                                    src={`${process.env.PUBLIC_URL}/assets/icons/whatsapp-contact-us.svg`}
                                    alt="whatsapp-logo"
                                />
                            </button>
                        </div>
                        <p>or visit our office address at</p>
                    </div>
                    <div className="office-address">
                        <ul className="branch-list">
                            {branches.map((branch, index) => (
                                <li key={index} className="branch-list-item">
                                    <strong>{branch.name}</strong> <br />
                                    <span>{branch.address}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                <div className="con-form">
                    <div>
                        <form className="contact-us-form">
                            <div className="display-phone">
                                <h1>How can we help?</h1>
                                <p>
                                    This is an investment product that has been designed to
                                    encourage a saving/investment culture.
                                </p>
                            </div>
                            <div>
                                <label className="display-lap">Name</label>
                                <input
                                    placeholder="Enter Full Name"
                                    className="form-control shadow-none"
                                />
                            </div>
                            <div>
                                <label className="display-lap">Email Address</label>
                                <input
                                    placeholder="Enter Email Address"
                                    className="form-control shadow-none"
                                />
                            </div>
                            <div>
                                <label className="display-lap">
                                    What would you love to tell us?
                                </label>
                                <textarea
                                    placeholder="Enter Message"
                                    className="form-control shadow-none"
                                    rows="10"
                                ></textarea>
                            </div>
                            <div>
                                <button className="btn btn-primary shadow-none">
                                    Send Message
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div className="container-fluid">
                <div className="mapouter w-100">
                    <div className="gmap_canvas">
                        <iframe
                            title="map-address"
                            className="ifame w-100"
                            id="gmap_canvas"
                            src="https://maps.google.com/maps?q=Checkoff%20Credit%20&t=&z=13&ie=UTF8&iwloc=&output=embed"
                            frameborder="0"
                            scrolling="no"
                            marginheight="0"
                            marginwidth="0"
                        ></iframe>
                    </div>
                </div>
            </div>

        </div>
    );
}


export default ContactUs